import { Component, Input } from '@angular/core';
import { SurveyJob } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'survey-job-detail-header',
    templateUrl: './survey-job-detail-header.component.html'
})
export class SurveyJobDetailHeaderComponent {
    @Input() job: SurveyJob;
    @Input() totalFeatureCount: number | null = null;
}
